import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { MessageSquare } from 'lucide-react';

export function ResponsesTab({ responses, injects, openResponseDialog, getFileUrl }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-secondary">Responses &amp; Notes</CardTitle>
      </CardHeader>
      <CardContent>
        {responses.length === 0 ? (
          <div className="py-8 text-center text-muted-foreground">
            <MessageSquare className="w-12 h-12 mx-auto mb-4 opacity-50" />
            <p>No responses submitted yet</p>
          </div>
        ) : (
          <div className="space-y-4">
            {responses.map((response) => {
              const inject = injects.find(i => i.inject_id === response.inject_id);
              return (
                <Card key={response.response_id} className="bg-muted/50">
                  <CardContent className="p-4">
                    <div className="flex items-start justify-between mb-2">
                      <div>
                        <p className="font-medium">
                          Response to: {inject?.title || 'Unknown Inject'}
                        </p>
                        <div className="flex items-center gap-2 mt-1">
                          {response.sender_role && (
                            <Badge variant="outline" className="text-[10px] capitalize">
                              {response.sender_role}
                            </Badge>
                          )}
                          <span className="text-xs text-muted-foreground">
                            {response.user_name || 'Unknown'} · {new Date(response.submitted_at).toLocaleString()}
                          </span>
                        </div>
                      </div>
                      {inject && (
                        <Button size="sm" variant="ghost" onClick={() => openResponseDialog(inject)}>
                          View Thread
                        </Button>
                      )}
                    </div>
                    <p className="text-sm whitespace-pre-wrap">{response.response_text}</p>
                    {!!(response.attachments || []).length && (
                      <div className="mt-2 flex gap-2 flex-wrap">
                        {(response.attachments_meta?.length ? response.attachments_meta : (response.attachments || []).map((fid) => ({ file_id: fid }))).map((att) => {
                          const fileId = att.file_id || att;
                          const filename = att.filename || fileId;
                          return (
                            <a key={fileId} href={getFileUrl(fileId)} target="_blank" rel="noreferrer" className="text-xs underline text-primary">
                              {filename}
                            </a>
                          );
                        })}
                      </div>
                    )}
                  </CardContent>
                </Card>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
